export const routeUrl = 'medical-partners/';
